import React from 'react';
import ProDetailSlideOver from './pro/ProDetailSlideOver';

interface ProDetailsViewProps {
  pronumber: number | string;
  /** @deprecated ProDetailSlideOver resolves the leg itself; accepted only for
   *  call-site compatibility. */
  legnum?: number;
  isOpen: boolean;
  onClose: () => void;
  /** @deprecated ProDetailSlideOver renders its own PRO links; accepted only
   *  for call-site compatibility. */
  ProNumberLink?: React.FC<{ pronumber: number | string }>;
  /** When set, opens the drawer in change-all mode anchored on `pronumber`,
   *  fanning the checked field edits out across every pro in `targetPros`.
   *  Forwarded verbatim to ProDetailSlideOver (same contract as /searchresults). */
  changeAll?: { targetPros: (number | string)[] } | null;
}

/**
 * ProDetailsView — reusable order-detail drawer keyed by PRO number.
 *
 * Thin wrapper around <ProDetailSlideOver>, which owns its own data fetch,
 * edit state, and save lifecycle. Kept as a named component so existing call
 * sites (LCDashboards, LiveMap, SmartDispatch, DispatchDashboard) compile
 * unchanged.
 *
 * Usage:
 * ```tsx
 * <ProDetailsView pronumber={123456} isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
 * ```
 */
export const ProDetailsView: React.FC<ProDetailsViewProps> = ({
  pronumber,
  isOpen,
  onClose,
  changeAll = null,
}) => {
  const proNum = Number(pronumber);
  return (
    <ProDetailSlideOver
      pronumber={Number.isFinite(proNum) && proNum > 0 ? proNum : null}
      isOpen={isOpen}
      onClose={onClose}
      changeAll={changeAll}
    />
  );
};
